import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { camposAPI, partidasAPI } from '../services/api';
import socketService from '../services/socket';
import { handicapDeJuego, parDelCampo, parPersonal } from '../utils/handicap';
import './JoinGame.css';

function JoinGame() {
  const navigate = useNavigate();
  const { codigo: codigoParam } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [campo, setCampo] = useState(null);

  const [formData, setFormData] = useState({
    codigo: codigoParam || '',
    nombre: '',
    handicap: ''
  });

  useEffect(() => {
    if (codigoParam) {
      setFormData(prev => ({ ...prev, codigo: codigoParam.toUpperCase() }));
    }
  }, [codigoParam]);

  useEffect(() => {
    // El campo se carga solo para poder mostrar el par personal del jugador
    camposAPI.getActual()
      .then(response => setCampo(response.data))
      .catch(err => console.error('Error al cargar el campo:', err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'codigo' ? value.toUpperCase() : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.codigo.trim()) {
      setError('Por favor, introduce el código de la partida');
      return;
    }

    if (!formData.nombre.trim()) {
      setError('Por favor, escribe tu nombre');
      return;
    }

    setLoading(true);

    try {
      const response = await partidasAPI.join(formData.codigo, {
        jugador: {
          nombre: formData.nombre.trim(),
          handicap: formData.handicap === '' ? 0 : Number(formData.handicap)
        }
      });

      // Guardar datos en localStorage
      localStorage.setItem('partidaCodigo', formData.codigo);
      localStorage.setItem('jugadorId', response.data.jugadorId);
      localStorage.setItem('jugadorNombre', formData.nombre.trim());

      // Notificar a otros jugadores via Socket
      socketService.nuevoJugador(formData.codigo, {
        id: response.data.jugadorId,
        nombre: formData.nombre.trim(),
        handicap: formData.handicap === '' ? 0 : Number(formData.handicap)
      });

      // Redirigir a sala de espera
      navigate(`/sala/${formData.codigo}`);
    } catch (err) {
      console.error('Error al unirse a partida:', err);
      setError(err.response?.data?.error || 'Error al unirse a la partida. Verifica el código.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="join-game">
      <div className="header">
        <h1>Unirse a Partida</h1>
        <p>Introduce el código compartido</p>
      </div>

      <div className="container">
        <div className="card fade-in">
          {error && <div className="error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="codigo">Código de Partida</label>
              <input
                type="text"
                id="codigo"
                name="codigo"
                value={formData.codigo}
                onChange={handleChange}
                placeholder="Ej: ABC123"
                required
                maxLength="10"
                style={{ textTransform: 'uppercase', textAlign: 'center', fontSize: '24px', fontWeight: 'bold', letterSpacing: '2px' }}
              />
              <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                El código te lo proporciona el creador de la partida
              </small>
            </div>

            <div className="form-group">
              <label htmlFor="nombre">Tu Nombre</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                placeholder="Ej: María García"
                required
                maxLength="50"
              />
            </div>

            <div className="form-group">
              <label htmlFor="handicap">Tu Handicap</label>
              <input
                type="number"
                id="handicap"
                name="handicap"
                value={formData.handicap}
                onChange={handleChange}
                placeholder="Ej: 18.5"
                min="0"
                max="54"
                step="0.1"
                required
              />
            </div>

            {campo && (
              <div className="par-personal">
                <div className="par-personal-label">Tu par en {campo.nombre}</div>
                <div className="par-personal-valor">
                  {parPersonal(parDelCampo(campo.hoyos), formData.handicap)}
                </div>
                <div className="par-personal-detalle">
                  Par {parDelCampo(campo.hoyos)} del campo + {handicapDeJuego(formData.handicap)} golpes
                  de tu handicap, repartidos hoyo a hoyo según su índice
                </div>
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary btn-full"
              disabled={loading}
            >
              {loading ? 'Uniéndose...' : 'Unirse a Partida'}
            </button>

            <button
              type="button"
              className="btn btn-secondary btn-full"
              onClick={() => navigate('/')}
              style={{ marginTop: '12px' }}
            >
              Cancelar
            </button>
          </form>
        </div>

        <div className="join-info">
          <div className="info-icon">ℹ️</div>
          <p>Puedes unirte a una partida escaneando el QR o introduciendo el código que te compartieron por WhatsApp.</p>
        </div>
      </div>
    </div>
  );
}

export default JoinGame;
